/**
 * @generated SignedSource<<2a8b06e9f8d3524a3f3040c126660085>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchResult_AtlassianSearchPage$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"searchResultRenderer_AtlassianSearchPage">;
  readonly " $fragmentType": "searchResult_AtlassianSearchPage";
};
export type searchResult_AtlassianSearchPage$key = {
  readonly " $data"?: searchResult_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResult_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAssets"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeCaseEmbeddedComments"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeCodeSearch"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeDatasourceId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeFastJiraHydration"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeJiraLiteModeFields"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeMercuryAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeNavBoostScore"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePassionfruitAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePositions"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeRisk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    }
  ],
  "kind": "Fragment",
  "name": "searchResult_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeAssets",
          "variableName": "includeAssets"
        },
        {
          "kind": "Variable",
          "name": "includeCaseEmbeddedComments",
          "variableName": "includeCaseEmbeddedComments"
        },
        {
          "kind": "Variable",
          "name": "includeCodeSearch",
          "variableName": "includeCodeSearch"
        },
        {
          "kind": "Variable",
          "name": "includeDatasourceId",
          "variableName": "includeDatasourceId"
        },
        {
          "kind": "Variable",
          "name": "includeFastJiraHydration",
          "variableName": "includeFastJiraHydration"
        },
        {
          "kind": "Variable",
          "name": "includeJiraLiteModeFields",
          "variableName": "includeJiraLiteModeFields"
        },
        {
          "kind": "Variable",
          "name": "includeMercuryAsk",
          "variableName": "includeMercuryAsk"
        },
        {
          "kind": "Variable",
          "name": "includeNavBoostScore",
          "variableName": "includeNavBoostScore"
        },
        {
          "kind": "Variable",
          "name": "includePassionfruitAsk",
          "variableName": "includePassionfruitAsk"
        },
        {
          "kind": "Variable",
          "name": "includePositions",
          "variableName": "includePositions"
        },
        {
          "kind": "Variable",
          "name": "includeRisk",
          "variableName": "includeRisk"
        },
        {
          "kind": "Variable",
          "name": "includeThirdPartyId",
          "variableName": "includeThirdPartyId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "searchResultRenderer_AtlassianSearchPage"
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};

(node as any).hash = "caf564c71ca927cfe80b321258b4a30a";

export default node;
